import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { fetchPermissions, selectPermissions, selectIsLoading } from '../features/permission/permission.slice';

const usePermissions = () => {
    const dispatch = useAppDispatch();
    const permissions = useAppSelector(selectPermissions);
    const isLoading = useAppSelector(selectIsLoading) as boolean | undefined;

    useEffect(() => {
        const getPermissions = async () => {
            await dispatch(fetchPermissions());
        };

        if (!permissions || permissions.length === 0) {
            getPermissions();
        }
    }, [dispatch, permissions]);

    return [permissions, isLoading] as const;
};

export default usePermissions;
